var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer2Left(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 365,
    viewBox: "0 0 548 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_594_27190)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.87,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.311 353.822L39.4841 358.05L0 360.479L92.8409 363.723L280.962 365.021L422.357 363.723L481.939 360.479L385.795 356.104L86.311 353.822Z",
    fill: "url(#paint0_linear_594_27190)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.309 68.8889L496.168 78.5597L548 110.335V116.28C534.061 129.44 517.567 140.602 499.191 149.311L486.309 151.802L448.197 182.678L458.03 187.953L387.574 236.6L390.979 239.07L387.853 242.482L358.456 274.32L346.667 284.556L337.622 292.385L326.239 346.935L271.942 349.845L264.802 350.222L269.884 343.188L273.416 338.269L280.174 286.482L286.602 281.479L260.89 212.276L273.746 196.389C273.746 196.389 242.748 171.458 238.861 166.141C236.015 162.143 228.418 153.184 224.861 149.018C223.718 147.658 222.981 146.821 222.981 146.821L248.135 133.403L261.575 126.244L254.766 115.024L245.695 120.948L211.268 128.107L200.291 133.11L184.792 129.656L147.697 74.8128L149.755 65.8536L150.339 63.279L147.798 52.0382H136.035C136.035 52.0382 118.986 46.9725 112.761 36.0038L104.427 5.17032C104.427 5.17032 152.118 0.020874 163.196 0.020874C174.274 0.020874 236.879 6.09135 236.879 6.09135L235.736 0.020874C235.736 0.020874 302.127 4.68892 328.805 7.97533C355.484 11.2617 411.686 19.1951 411.686 19.1951C411.686 19.1951 513.445 19.0486 547.898 26.8146V30.5614L500.309 68.8889Z",
    fill: "url(#paint1_linear_594_27190)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548 30.5405L471.928 38.0344L401.929 43.9583L350.097 52.729H330.05L278.218 24.0096L243.028 9.67081L235.837 0L242.647 18.7137L329.288 55.4921L362.598 58.297L401.192 55.4921L424.365 63.2789L452.263 75.4407L490.476 81.6786L496.168 78.5597L500.309 68.8889L548 30.5405Z",
    fill: "url(#paint2_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.028 119.085L254.741 115.024L245.67 120.948L211.242 128.107L200.266 133.11L184.767 129.677L147.697 74.8127L170.005 98.8014L192.313 105.353L243.028 119.085Z",
    fill: "url(#paint3_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.642 284.556L337.622 292.385L326.214 346.935L271.917 349.845L269.833 343.188L273.339 338.269L280.098 286.482L295.292 296.446H303.55L346.642 284.556Z",
    fill: "url(#paint4_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548 116.28C534.061 129.44 517.567 140.602 499.191 149.311L486.309 151.802L448.197 182.678L419.435 178.136L366.282 182.531L384.627 185.483H428.15L458.03 187.953L387.574 236.6L373.955 235.658L358.71 245.329L333.734 252.802L369.305 249.369L387.752 242.482L358.355 274.32L346.565 284.556L332.235 286.482L301.187 288.952L286.526 281.479L260.813 212.276L268.766 218.556L322.682 212.946L358.05 199.843L378.376 187.995H364.376L349.64 190.821L306.268 199.843L279.768 202.961L273.721 196.431C273.721 196.431 242.748 171.458 238.861 166.141C236.015 162.143 228.418 153.184 224.861 149.018L247.83 153.372L255.452 156.638L295.165 154.293L370.83 137.861L326.137 133.403L285.713 135.496L253.928 133.403H248.033L261.474 126.244L254.665 115.024L245.975 108.744L183.929 90.6587L149.729 65.8745L150.314 63.2999L147.773 52.0591H136.035C136.035 52.0591 118.986 46.9934 112.761 36.0248L104.427 5.17029L113.244 19.3416L151.356 43.9791L257.485 83.8556L299.865 93.2124L403.53 97.5873L462.477 126.579H492.763L548 116.28Z",
    fill: "url(#paint5_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.309 68.8888L458.691 61.709L432.216 52.7289L442.43 43.9582L489.714 40.8393L511.87 34.099L432.216 41.3835L401.929 43.9582L362.598 58.297L401.193 55.492L448.477 74.8127L490.476 81.6786L496.168 78.5596L500.309 68.8888Z",
    fill: "url(#paint6_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.477 126.579L441.667 155.256L391.919 175.121L362.598 177.068L370.906 137.882L297.706 153.791L294.098 190.486L283.935 199.215L273.771 196.41L279.818 202.941L306.268 199.843L364.529 187.995L366.231 182.573L419.385 178.178L448.147 182.72L486.259 151.844L499.14 149.353C499.14 149.353 532.806 132.21 547.949 116.322L492.763 126.579H462.477Z",
    fill: "url(#paint7_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.478 187.974L373.93 235.658L358.812 245.329L351.037 214.621L358.05 199.801L378.478 187.974Z",
    fill: "url(#paint8_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.382 249.369L346.641 284.556L361.124 271.39L387.828 242.482L369.382 249.369Z",
    fill: "url(#paint9_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.55 296.446L290.896 348.84L326.214 346.935L337.622 292.385L346.642 284.556L303.55 296.446Z",
    fill: "url(#paint10_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.192 55.4921L416.082 42.7651L401.929 43.9583L350.097 52.729H330.05L329.288 55.4921L362.598 58.2971L401.192 55.4921Z",
    fill: "url(#paint11_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.454 97.5664L370.906 137.861L326.213 133.403L317.753 98.927L297.833 97.5664L260.051 84.4208L299.789 93.1915L403.454 97.5664Z",
    fill: "url(#paint12_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.667 155.235L481.634 147.051L499.191 149.311L486.309 151.823L448.096 182.678L419.334 178.156L366.206 182.531L391.919 175.1L441.667 155.235Z",
    fill: "url(#paint13_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.098 190.465L341.89 187.974H364.503L308.682 199.298L279.717 202.92L273.695 196.389L283.884 199.194L294.098 190.465Z",
    fill: "url(#paint14_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.382 249.369L346.641 284.556L387.828 242.482L369.382 249.369Z",
    fill: "url(#paint15_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.896 348.84L303.55 296.446L319.938 287.466L333.836 252.802L322.682 212.904L358.05 199.801L378.478 187.974H364.503L279.717 202.92L294.098 190.465L297.706 153.77L370.906 137.861L326.213 133.403L317.753 98.927L403.454 97.5664L462.477 126.558H492.763L548 116.28L499.191 149.312L486.309 151.823L448.096 182.678L419.334 178.157L387.828 180.752L407.087 185.483L457.929 187.974L387.548 236.6L373.93 235.658L355.865 245.957L346.641 251.567L369.382 249.369L387.828 242.482L346.641 284.556L337.622 292.385L326.213 346.935L290.896 348.84Z",
    fill: "url(#paint16_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.716 155.905L297.706 164.864L367.247 159.61L416.082 142.697L454.27 137.861L529.909 131.016L515.935 140.604L469.769 147.051L444.005 152.012H425.737L365.596 163.273L295.241 178.805L254.741 180.773L226.716 155.905Z",
    fill: "#93839C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.354 187.974L294.53 186.299L363.487 170.432L417.555 164.864L481.253 155.905L475.689 159.61L422.332 164.864L413.846 166.351L362.598 173.572L294.098 190.465H276.871L268.588 192.265L263.354 187.974Z",
    fill: "#93839C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.833 236.537L323.241 239.677L357.974 232.707L378.478 214.516H419.512L401.294 227.097L377.03 225.38L357.77 237.772L331.752 245.308H273.085L269.833 236.537Z",
    fill: "#93839C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.299 272.813L322.174 281.856L351.037 277.732L358.177 275.304L353.73 278.402L349.462 280.286L320.751 284.556L284.366 275.681L283.299 272.813Z",
    fill: "#93839C"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.837 0L243.028 9.67081L278.218 24.0096L330.05 52.729H350.097L403.454 43.8327L416.082 42.7651L411.788 19.1742L286.272 3.87251L235.837 0Z",
    fill: "#5955B1"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.028 119.085L199.377 124.548L184.767 129.677L200.266 133.11L211.242 128.107L245.67 120.948L254.741 115.024L243.028 119.085Z",
    fill: "url(#paint17_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.697 52.0591V42.7651L136.263 34.2246L133.849 49.0239L123.686 46.4701L135.958 52.0591H147.697Z",
    fill: "url(#paint18_linear_594_27190)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.629 52.729L254.741 72.573L304.185 78.162L337.418 94.7824L299.789 93.1915L254.741 84.4208L174.629 52.729Z",
    fill: "#503E7F"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.55 126.244L293.818 131.016L254.741 115.024L261.55 126.244Z",
    fill: "url(#paint19_linear_594_27190)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.647 354.115V346.014L212.106 328.85C212.106 328.85 230.832 308.733 235.278 296.509C212.679 271.21 183.242 250.592 149.297 236.286C149.297 236.286 109.178 223.727 88.7502 223.727L92.4344 245.894C92.4344 245.894 101.886 264.608 128.006 294.227L129.124 328.808L141.243 340.048L140.481 343.775H136.314L126.151 352.148L214.647 354.115Z",
    fill: "url(#paint20_linear_594_27190)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.291 223.81L110.22 263.582L126.1 269.694L207.406 296.509H235.126L211.954 328.85L205.144 334.773H188.858L154.049 313.841L127.955 294.206L161.849 328.787L177.907 332.073L188.477 336.26L207.609 334.857L212.36 331.487L214.596 345.93V354.031L126.049 352.126L136.212 343.753L146.63 348.756L166.118 351.247L140.379 343.753L141.142 340.027L129.022 328.787L127.904 294.206C127.904 294.206 101.784 265.822 92.3327 245.873L88.5469 223.747L91.291 223.81Z",
    fill: "url(#paint21_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.553 336.343V353.55L214.647 354.115V346.014L212.411 331.571L207.66 334.941L188.553 336.343Z",
    fill: "url(#paint22_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.934 334.794L194.702 310.931L207.456 296.446L235.177 296.509L218.229 320.184L212.004 328.85L205.195 334.794H188.934Z",
    fill: "url(#paint23_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.243 340.09L159.791 347.417L166.219 351.31L140.481 343.816L141.243 340.09Z",
    fill: "url(#paint24_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.92 278.674L181.591 305.887L194.676 311.036L230.247 305.928C225.61 312.975 220.228 319.671 214.164 325.94H188.909L127.929 294.374L114.92 278.674Z",
    fill: "#93839C"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.427 251.378L138.626 273.755L106.968 263.75L104.427 251.378Z",
    fill: "#503E7F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.686 354.513L386.939 329.394C386.939 329.394 421.621 290.69 429.37 270.469L424.746 263.666C424.746 263.666 367.425 277.063 315.288 321.691L308.479 343.607L300.856 338.311C300.856 338.311 270.951 334.229 250.498 339.902L241.478 360.165C241.478 360.165 298.443 362.844 324.664 361.839L322.682 356.669L425.686 354.513Z",
    fill: "url(#paint25_linear_594_27190)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.644 263.729L401.625 300.779L343.186 334.501L315.237 321.753L308.428 343.67L300.805 338.374L310.181 349.824L261.906 348.568L250.498 339.965L241.478 360.227L281.14 361.672L324.664 361.902L322.682 356.732L425.584 354.513L386.837 329.394C386.837 329.394 420.096 291.883 429.268 270.469L424.644 263.729Z",
    fill: "url(#paint26_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.837 329.457L341.992 355.769L343.161 334.501L401.65 300.779L386.837 329.457Z",
    fill: "url(#paint27_linear_594_27190)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.377 343.67L322.682 356.732L324.664 361.902L310.232 349.845L300.882 338.374L308.377 343.67Z",
    fill: "url(#paint28_linear_594_27190)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_594_27190",
    x1: 0,
    y1: 359.411,
    x2: 481.939,
    y2: 359.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_594_27190",
    x1: 326.214,
    y1: 350.222,
    x2: 326.214,
    y2: -0.0000634455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F1659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#572C78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_594_27190",
    x1: 235.837,
    y1: 40.8393,
    x2: 548,
    y2: 40.8393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_594_27190",
    x1: 147.697,
    y1: 103.972,
    x2: 254.741,
    y2: 103.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_594_27190",
    x1: 269.833,
    y1: 317.19,
    x2: 346.642,
    y2: 317.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_594_27190",
    x1: 104.427,
    y1: 147.051,
    x2: 548,
    y2: 147.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_594_27190",
    x1: 362.598,
    y1: 57.8783,
    x2: 511.87,
    y2: 57.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_594_27190",
    x1: 273.67,
    y1: 159.589,
    x2: 548,
    y2: 159.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_594_27190",
    x1: 351.063,
    y1: 216.651,
    x2: 378.478,
    y2: 216.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_594_27190",
    x1: 346.641,
    y1: 263.519,
    x2: 387.828,
    y2: 263.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_594_27190",
    x1: 290.896,
    y1: 316.688,
    x2: 346.642,
    y2: 316.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_594_27190",
    x1: 329.288,
    y1: 50.5311,
    x2: 416.082,
    y2: 50.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_594_27190",
    x1: 260.051,
    y1: 111.152,
    x2: 403.454,
    y2: 111.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_594_27190",
    x1: 366.18,
    y1: 164.864,
    x2: 499.191,
    y2: 164.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_594_27190",
    x1: 273.67,
    y1: 195.447,
    x2: 364.478,
    y2: 195.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_594_27190",
    x1: 346.641,
    y1: 263.519,
    x2: 387.828,
    y2: 263.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_594_27190",
    x1: 279.717,
    y1: 223.203,
    x2: 548,
    y2: 223.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_594_27190",
    x1: 184.767,
    y1: 124.067,
    x2: 254.741,
    y2: 124.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_594_27190",
    x1: 123.686,
    y1: 43.1419,
    x2: 147.697,
    y2: 43.1419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_594_27190",
    x1: 254.741,
    y1: 123.02,
    x2: 293.818,
    y2: 123.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_594_27190",
    x1: 161.9,
    y1: 354.115,
    x2: 161.9,
    y2: 223.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#633B78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_594_27190",
    x1: 88.6486,
    y1: 288.952,
    x2: 235.177,
    y2: 288.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_594_27190",
    x1: 188.553,
    y1: 342.832,
    x2: 214.647,
    y2: 342.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_594_27190",
    x1: 188.909,
    y1: 315.62,
    x2: 235.177,
    y2: 315.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_594_27190",
    x1: 140.481,
    y1: 345.7,
    x2: 166.219,
    y2: 345.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_594_27190",
    x1: 335.23,
    y1: 354.637,
    x2: 331.347,
    y2: 260.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#633B78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_594_27190",
    x1: 236.024,
    y1: 311.508,
    x2: 428.466,
    y2: 299.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_594_27190",
    x1: 341.992,
    y1: 328.284,
    x2: 401.65,
    y2: 328.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_594_27190",
    x1: 300.882,
    y1: 350.138,
    x2: 324.689,
    y2: 350.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_594_27190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 548,
    height: 365,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2Left);
export default __webpack_public_path__ + "static/media/layer2left.09c490bdce0810863c8899987c490f64.svg";
export { ForwardRef as ReactComponent };